// Import jQuery once
import $ from 'jquery';

// Expose the same instance globally
window.$ = window.jQuery = $;

require("./shop/plugins.js");
require("../vendors/broccoli/js/main.js");
import "../styles/shop/style.scss";
import "./shop/checkout/shipping_address.js";

/* --------------------------------------------------------
   Importing Legacy Oscar Module
-------------------------------------------------------- */
// Assign the module to window.oscar
import oscarModule from "../vendors/oscar/js/ui.js"; //  ui.js fixed to export
window.oscar = window.oscar || {};
window.oscar = oscarModule; // now window.oscar.init exists

jQuery(function() {
    window.oscar.init();
});

import { PromiseAjaxPostForm } from "./globals.js"
import { PromiseAjaxGet } from "./globals.js"
import { ReplaceAjax } from "./globals.js"
/* --------------------------------------------------------
    1. Functions
-------------------------------------------------------- */


function UpdateQueryParam(SearchParam_object) {

    const url = new URL(window.location);
    
    //console.log("SearchParam_object: ", SearchParam_object);
    
    for (const [key, value] of SearchParam_object) {
        //console.log(key, value)
        if (key === "selected_facets") {
            // Allow multiple instances
            url.searchParams.append(key, value);
            url.searchParams.delete("page");
        }
    
        if (key === "sort_by" || key === "q") {
            // Replace existing key/value pair or added if new
            url.searchParams.set(key, value);
            url.searchParams.delete("page");
        }
    
        if (key === "page") {
            url.searchParams.set(key, value);
        }
        
    }
    
    
    
    window.history.pushState({}, "", url);
}
    
function RemoveQueryParam(SearchParam_object) {
    
    const url = new URL(window.location);
    
    
    for (const [key, value] of SearchParam_object) {
    
        url.searchParams.delete(key, value);
    
    }
    
    window.history.pushState({}, "", url);
}

function ShowGenericErrorModal(){
    CloseAllModals().then(function(){
        var modal_el_error = document.getElementById("modal_error");
        $(modal_el_error).modal('show');
    })
}

function ResetActiveChildren(){
    const selected_children_array = Object.values(JSON.parse(document.getElementById('selected_children').textContent))
    const els = document.getElementsByClassName("arm__child");

    //console.log("selected_children_array: ", selected_children_array);
    for(let i=0; i<els.length; i++){
        
        if (selected_children_array.includes(els[i].getAttributeNode("value").value)){
            els[i].classList.add('active');
            els[i].classList.remove('d-none');
            //console.log("value ", els[i].getAttributeNode("value").value, " is selected!");
        } else {
            els[i].classList.add('d-none');
            els[i].classList.remove('active');
        }
    }

}

function UpdateFacetsCounts() {

    // Count Products
    var n_pr_standalone = document.getElementsByClassName("ltn__product-item active").length;
    var n_pr_children_active = document.getElementsByClassName("arm__child active").length;
    let n_pr = n_pr_standalone + n_pr_children_active
    // Update total number of elements shown
    
    var els = document.getElementsByClassName("products_shown");
    let label = ngettext("Product", "Products", n_pr);

    for(let i=0; i<els.length; i++){
        els[i].innerHTML = n_pr +" "+label;
    }

}

function CloseAllModals(){

    return new Promise((resolve, reject) => {
        setTimeout(function() {
            var els = $(".modal");
            if(els){
                for(let i=0; i<els.length; i++){
                    //console.log(els[i]);
                    $(els[i]).modal('hide');
                }
            }
            resolve();
        }, 1000);
    })

}

function HideScrollbarOptionsBar(handler) {

    for (let i = 0; i < handler.length; i++) {
        let horizontalScrollbarHeight = handler[i].offsetHeight - handler[i].clientHeight; 
        handler[i].style["padding-bottom"] = horizontalScrollbarHeight + "px";
    }
}

function PostForm($form, $modal_success, $modal_error) {
    PromiseAjaxPostForm($form)
        .then(function ($ajax_data) {

            const hasErrors =
                $ajax_data
                    .find(".modal[id=modal_alert_messages]")
                    .find(".alert-danger")
                    .length > 0;

            if (!hasErrors) {

                // Meta Pixel: aggiunta al carrello confermata
                if (typeof window.fbq === "function") {
                    window.fbq("track", "AddToCart");
                    console.log("[Meta Pixel] AddToCart inviato");
                } else {
                    console.warn("[Meta Pixel] fbq non disponibile");
                }

                CloseAllModals()
                    .then(function () {
                        ReplaceAjax($ajax_data);
                        $modal_success.modal("show");
                    });

            } else {
                ReplaceAjax($ajax_data);

                if ($(".modal-open").length === 0) {
                    $modal_error.modal("show");
                }
            }
        })
        .catch(function (error) {
            console.log("Error!");
            console.log(error);
            ShowGenericErrorModal();
        });
}

function ActiveTab($a, $tab, tab_id){
    for(let i=0; i<$a.length; i++){
        if($($a[i]).attr("href") !== "#"+tab_id){
            if($($a[i]).hasClass("active")){
                $($a[i]).removeClass("active");
            }
        } else {
            if(!$($a[i]).hasClass("active")){
                $($a[i]).addClass("active");  
            }
        };
    };
    
    for(let i=0; i<$tab.length; i++){

        if($($tab[i]).attr("id") !== tab_id){
            if($($tab[i]).hasClass("active")){
                $($tab[i]).removeClass("active");
                $($tab[i]).removeClass("show");
            }
        } else {
            if(!$($tab[i]).hasClass("active")){
                $($tab[i]).addClass("active");  
                $($tab[i]).addClass("show");  
            }
        };
    };
}

function ResetAndShowModalForm($modal_el, btn_text){

    // Remove (if exists) previous callbacks errors
    $modal_el.find(".modal-error-message").html("");

    // Reset Form
    $modal_el.find("form")[0].reset();

    // Reset Button    
    $modal_el.find(":submit").html(btn_text);
    $modal_el.find(":submit").removeClass('disabled').prop('disabled', false);

    // Show Modal
    $modal_el.modal('show');
}

/* --------------------------------------------------------
    Product Reviews
-------------------------------------------------------- */
$("body").on("click" , "a#reviews-list" , function(ev){
    ev.preventDefault();

    var $a = $(".ltn__shop-details-tab-inner .ltn__shop-details-tab-menu a");
    var $tab = $(".ltn__shop-details-tab-inner .tab-pane");
    ActiveTab($a, $tab, "liton_tab_details_1_2");

    // Activate Reviews Tab
    $('html, body').animate({
        scrollTop: $("#liton_tab_details_1_2").offset().top
    }, 1000);
});

$("body").on("click" , "[id^=write_review]" , function(ev){
    ev.preventDefault();

    var $modal_form = $("#modal_add_review");
    var $modal_form_el = $("#modal_add_review form");

    // Set form action URL
    $modal_form_el.attr("action",ev.target.href);

    PromiseAjaxGet(ev.target.href)
        .then(function($ajax_data){
            // Update Elements
            ReplaceAjax($ajax_data)
            // Set form action URL
            var $modal_form_el = $("#modal_add_review form");
            $modal_form_el.attr("action",ev.target.href);
            // Reset form
            ResetAndShowModalForm($modal_form, "Submit");
        })



});

$("body").on("submit", "form[id=add_review_form], .review_votes form", function(ev){
    ev.preventDefault();
    PostForm($(ev.target), $("#modal_alert_messages"), $("#modal_alert_messages"));    
});
/* --------------------------------------------------------
    Countdown
--------------------------------------------------------- */
$('[data-countdown]').each(function () {
    var $this = $(this),
        finalDate = $(this).data('countdown');
    if (!$this.hasClass('countdown-full-format')) {
        $this.countdown(finalDate, function (event) {
            $this.html(event.strftime('<div class="single"><h1>%D</h1><p>Days</p></div> <div class="single"><h1>%H</h1><p>Hrs</p></div> <div class="single"><h1>%M</h1><p>Mins</p></div> <div class="single"><h1>%S</h1><p>Secs</p></div>'));
        });
    } else {
        $this.countdown(finalDate, function (event) {
            $this.html(event.strftime('<div class="single"><h1>%Y</h1><p>Years</p></div> <div class="single"><h1>%m</h1><p>Months</p></div> <div class="single"><h1>%W</h1><p>Weeks</p></div> <div class="single"><h1>%d</h1><p>Days</p></div> <div class="single"><h1>%H</h1><p>Hrs</p></div> <div class="single"><h1>%M</h1><p>Mins</p></div> <div class="single"><h1>%S</h1><p>Secs</p></div>'));
        });
    }
});

/* --------------------------------------------------------
    Back-in-Stock Alerts
-------------------------------------------------------- */
// Show Modal after "NOTIFE ME" button clicked if user is not logged
$("body").on("click" , "[id^=back_in_stock_btn]" , function(ev){
    ev.preventDefault();

    var $modal_form = $("#back_in_stock_modal");
    var $modal_form_el = $("#back_in_stock_modal form");

    // Set form action URL
    $modal_form_el.attr("action",ev.target.href);

    // Set product tag
    if($(ev.target).closest(".ltn__product-item").find(".arm__child").length > 0){
        var title = $(ev.target).closest(".arm__child").find(".product-title").text().trim();
        
    } else {
        var title = $(ev.target).closest(".ltn__product-item").find(".product-title").text().trim();
    }
    $modal_form_el.find(".form-title span").text(title);

    // Reset form
    ResetAndShowModalForm($modal_form, "Notify me!");

});

// Send POST request to web server and wait for promise to be settled...
$("body").on("submit" , "form[id=back_in_stock_modal_form], form[id^=back_in_stock_form]" , function(ev){
    ev.preventDefault();
    PostForm($(ev.target), $("#modal_alert_messages"), $("#modal_alert_messages"));
});

/* --------------------------------------------------------
    Add to Basket
-------------------------------------------------------- */
$("body").on("submit" , "form[id^=add_to_basket_form]" , function(ev){
    ev.preventDefault();
    PostForm($(ev.target), $("#modal_alert_messages_checkout"), $("#modal_alert_messages"));
});

/* --------------------------------------------------------
    Remove Products From Mini Basket (TBD)
-------------------------------------------------------- */
jQuery(function () {
    $(document).on('click', '.mini-cart-item-delete', function (ev) { 
    })
})

/* --------------------------------------------------------
    Remove Sticky Header
-------------------------------------------------------- */
jQuery(function () {
    $(".ltn__header-middle-area").removeClass("ltn__header-sticky");
})

/* --------------------------------------------------------
    Facets Calls 
-------------------------------------------------------- */
$("#content_inner").on('click', '.sidebar_filters a', function (ev) {
    // You are here if facet turns from unselected to selected
    ev.preventDefault();

    var filter_value = $(this).parent().attr('value');

    const urlParams = new URLSearchParams();
    urlParams.append("selected_facets", filter_value);

    UpdateQueryParam(urlParams);

    //  Substitute link with strong name
    $('.facet_checkbox[name="'+filter_value+'"]').nextAll('a').hide();
    $('.facet_checkbox[name="'+filter_value+'"]').nextAll('strong').show();

    // Tick Checkbox
    $('.facet_checkbox[name="'+filter_value+'"]').prop("checked", true);

    // Update Page
    PromiseAjaxGet("")
    .then(function($ajax_data){
        ReplaceAjax($ajax_data);
        ResetActiveChildren();
        UpdateFacetsCounts();
        })

})

$("#content_inner").on('change', '.facet_checkbox', function (ev) {
    
    // You are here if facet turns from unselected to selected
    ev.preventDefault();
    var filter_value = $(this).parent().attr('value');

    const urlParams = new URLSearchParams();
    urlParams.append("selected_facets", filter_value);

    if ($(this).is(":checked")) {

        // Update all checkbox status accross the DOM
        $('.facet_checkbox[name="'+filter_value+'"]').prop("checked", true);

        //  Substitute link with strong name
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('a').hide();
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('strong').show();

        UpdateQueryParam(urlParams);

    } else {

        // Update all checkbox status accross the DOM
        $('.facet_checkbox[name="'+filter_value+'"]').prop("checked", false);

        //  Substitute strong name with link
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('a').show();
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('strong').hide();

        RemoveQueryParam(urlParams);

    }

    // Update Page
    PromiseAjaxGet("")
        .then(function($ajax_data){
            ReplaceAjax($ajax_data);
            ResetActiveChildren();
            UpdateFacetsCounts();
            })

})

$("#content_inner").on('change', '#id_sort-by-form', function (ev) {
    ev.preventDefault();

    const urlParams = new URLSearchParams($('#id_sort-by-form').serialize());

    UpdateQueryParam(urlParams);
    PromiseAjaxGet("")
        .then(function($ajax_data){
            ReplaceAjax($ajax_data);
            ResetActiveChildren();
            UpdateFacetsCounts();
            })
})

/* --------------------------------------------------------
    Show Active Children
-------------------------------------------------------- */
jQuery(function () {
    if(document.getElementById('selected_children')){
        ResetActiveChildren();
    }
})

/* --------------------------------------------------------
    Variant Selection
-------------------------------------------------------- */
jQuery(function () {
    $(document).on('click', ".arm__variant-option > button", function(){

        if(!$(this).closest(".arm__variant-option").hasClass("active")){
            const ch_sel_value = $(this).closest(".arm__variant-option").attr("value");
            const children = $(this).closest(".ltn__product-item").find(".arm__child");
            
            // Deactivate current child
            $(this).closest(".arm__child").addClass("d-none");
            $(this).closest(".arm__child").removeClass("active");

            // Active selected child
            for(let i=0;i<children.length;i++){
                if(children[i].getAttributeNode("value").value === ch_sel_value){
                    children[i].classList.add('active');
                    children[i].classList.remove('d-none'); 
                }
            }
        }
    })
    
})

/* --------------------------------------------------------
    Update Facets Count
-------------------------------------------------------- */
jQuery(function () {
    UpdateFacetsCounts();
})

/* --------------------------------------------------------
    Grid Scrollbar Option
-------------------------------------------------------- */
jQuery(function () {
    HideScrollbarOptionsBar(document.querySelectorAll('[id^=add_to_basket_form_]'));
    ResetPositionScrollbarOptionsBar(document.querySelectorAll('[id^=add_to_basket_form_]'));
})

/* --------------------------------------------------------
    Checkout Gateway
-------------------------------------------------------- */
jQuery(function(){

    var $input_password = $(".arm__checkout-gateway .input-item-password");
    var $login_option = $(".arm__checkout-gateway #id_options_2");
    var $newsletter = $(".arm__checkout-gateway .newsletter-subscribe");

    var $login_form_errors = $(".arm__checkout-gateway .login-errors");
    var $guest_form_errors = $(".arm__checkout-gateway .guest-errors");
    
    if($login_option.is(':checked')){
        $input_password.show();
        $newsletter.hide();

        for(let i=0; i<$login_form_errors.length; i++){$($login_form_errors[i]).show();}
        for(let i=0; i<$guest_form_errors.length; i++){$($guest_form_errors[i]).hide();}

    }else{
        $newsletter.show();
        $input_password.hide();

        for(let i=0; i<$login_form_errors.length; i++){$($login_form_errors[i]).hide();}
        for(let i=0; i<$guest_form_errors.length; i++){$($guest_form_errors[i]).show();}
    }


    $("body").on("click", ".arm__checkout-gateway input[type=radio]", function(){
        var $input_password = $(".arm__checkout-gateway .input-item-password");
        var $login_option = $(".arm__checkout-gateway #id_options_2")
    
        if($login_option.is(':checked')){
            $input_password.show();
            $newsletter.hide();

            for(let i=0; i<$login_form_errors.length; i++){$($login_form_errors[i]).show();}
            for(let i=0; i<$guest_form_errors.length; i++){$($guest_form_errors[i]).hide();}
        }else{
            $input_password.hide();
            $newsletter.show();

            for(let i=0; i<$login_form_errors.length; i++){$($login_form_errors[i]).hide();}
            for(let i=0; i<$guest_form_errors.length; i++){$($guest_form_errors[i]).show();}
        }
    })
})

/* --------------------------------------------------------
    Checkout Shipping Form
-------------------------------------------------------- */
function close_billing_cards(){
    $('#arm__checkout-billing-selection .card .ltn__card-title').addClass('collapsed');
    $('#arm__checkout-billing-selection .card .collapse.show').removeClass('show');
}

jQuery(function(){

    // Init
    for(let i=0; i<$('#arm__checkout-billing-selection input').length; i++){
        let $bill_option = $($('#arm__checkout-billing-selection input[id^=id_bill_options]')[i])
        if($bill_option.prop('checked')){

            // Underline active option
            $bill_option.closest('label').css( "border-bottom", "2px solid #e4ecf2" );
            
            // Open active card
            $bill_option.closest('.card').find('.collapsed').removeClass('collapsed');
            $bill_option.closest('.card').find('.collapse').addClass('show');

            // Reset (not submitted) fields
            $bill_option.closest('.card').find('.card-body input')

        } else {
            // Close card
            $bill_option.closest('.card').find('.ltn__card-title').addClass('collapsed');
            $bill_option.closest('.card').find('.collapse.show').removeClass('show');

            // Reset fields
            $bill_option.closest('.card').find('.card-body input').prop('value', '')
        }
    }


    // On option click
    $("body").on("click", "[id^=id_bill_options_]", function(){
        for(let i=0; i<$('#arm__checkout-billing-selection input').length; i++){

            // Unset 
            $($('#arm__checkout-billing-selection input')[i]).closest('label').css( "border-bottom", "unset" )
        }
        $(this).closest('label').css( "border-bottom", "2px solid #e4ecf2" );
  
    })

})